
import {
    ref,
    watch,
  } from 'vue'
  import { store } from "@/store"
  import { postDrc } from '@/api/monitorApi/drc'
  import {
    UranusMqtt,
  } from '@/mqtt'
  
  type StatusOptions = {
    status: 'close';
    event?: CloseEvent;
  } | {
    status: 'open';
    retryCount: number;
  } | {
    status: 'pending';
  }
  
  export function useConnectMqtt () {
    
    const mqttState = ref<UranusMqtt | null>(null)
  
    // 监听已打开的设备小窗 窗口数量
    watch(() => store.informationListStore.informationStore().airNumberValue, async (val) => {
      // 1.打开小窗
      // 2.设备拥有飞行控制权
      // 3.请求建立mqtt连接的认证信息
      if (val) {
        const globalMqttState = store.other.useMyStore().mqttState
        if (globalMqttState) {
          mqttState.value = globalMqttState
          return
        }
        if (mqttState.value) return
        let params:any = {}
        params.workspaceId = localStorage.getItem("Workspace_id")
        const result = await postDrc(params,{})
        console.log(result)
        if (result.clientId) {
          // @TODO: 校验 expire_time
          mqttState.value = new UranusMqtt(result.address, {
            clientId: result.clientId,
            username:result.username,
            password:result.password,
          })
          mqttState.value?.initMqtt()
          mqttState.value?.on('onStatus', (statusOptions: StatusOptions) => {
            // @TODO: 异常case
          })
          console.log(result.clientId)
          store.other.useMyStore().setMqttState(mqttState.value);
          store.other.useMyStore().setClientId(result.clientId);
        }
        // @TODO: 认证失败case
        return
      }
      // 关闭所有小窗后
      // 1.销毁mqtt连接重置mqtt状态
      if (mqttState?.value) {
        mqttState.value?.destroyed()
        mqttState.value = null
        store.other.useMyStore().setMqttState(null);
        store.other.useMyStore().setClientId("");
      }
    }, { immediate: true })
  }
  